<template>
  <div ref="frisbuy-widget-gallery" :class="{ 'frisbuy-widget': true, 'frisbuy-class': true, 'frisbuy-vertical': isVerticalGallery, [`frisbuy-layout-${ gallerySettings.layout }`]: gallerySettings.layout, [`frisbuy-${ settings.customerCode }`]:true}" :style="[galleryStyle]">
    <!-- <script src="https://connect.facebook.net/en_US/all.js" async="" type="application/javascript" v-if="settings.popup.shareButtons.fb"></script> -->
    <div class="frisbuy-header">
      <div class="frisbuy-title" v-if="headerSettings.title || headerSettings.buttonTitle">
        {{headerSettings.title}}<a v-if="headerSettings.buttonTitle" :href="headerSettings.buttonLink">{{headerSettings.buttonTitle}}</a>
      </div>
      <div v-if="headerSettings.subTitle" class="frisbuy-subtitle" :style="[subTitleStyle]">{{headerSettings.subTitle}}</div>
      <div v-if="headerSettings.html" v-html="headerSettings.html"></div>
    </div>
    <div class="frisbuy-categories" v-if="gallerySettings.filters.params">
      <a
        v-for="filter in gallerySettings.filters.params"
        :href="`#${gallerySettings.filters.field}=${filter.value ? filter.name : 'Все'}`"
        :class="{ 'frisbuy-category': true, 'frisbuy-active': filterValue == filter.value || (filterValue == null && !filter.value) }"
        @click="chosenFilter(filter)">{{filter.name}}</a>
    </div>
    <div class="frisbuy-gallery">
      <div
        :class="{ 'frisbuy-scroll-wrapper': true, 'no-scroll-width': !isVerticalGallery && scrollWidth < 0 }"
        :style="{ height: isVerticalGallery && gallerySettings.maxCols && `${ ((containerItemHeight + containerItemMargin) * gallerySettings.maxCols) }px`}"
        v-touch:swipe="swipeHandler"
        ref="postsScroll"
        @mousedown.stop="handleMouseDownScroll"
        @mouseleave.stop="handleMouseLeaveScroll"
        @mouseup.stop="handleMouseUpScroll"
        @mousemove.stop="handleMouseMoveScroll"
        >
        <div ref="swiper" :style="{ padding: isLineRowsMode && scrollWidth < 0 && `0 ${ containerItemMargin / 2}px` }">
          <ul
            class="swiper-wrapper"
            :class="{ 'frisbuy-gallery-posts': true, [`frisbuy-scheme-${ gallerySettings.scheme }`]: gallerySettings.layout == 'tile' && gallerySettings.scheme }"
            :style="{ width: `calc(100% + ${ containerItemMargin }px)`, maxHeight: !isVerticalGallery && isLineRowsMode && containerRowsHeight }"
          >
            <template v-for="(post, index) in postList">
              <li v-if="gallerySettings.scheme && !isTablet && (index == 5 || !((index - 5) % 9))" class="frisbuy-divider"></li>
              <template v-if="post.frisbuyPost.type === 'advertising'"></template>
              <post-item
                v-else
                class="swiper-slide"
                :post="post"
                :key="post.frisbuyPost.id"
                :index="index"
                ref="postImage"
                :settings="settings"
                :mobile-settings="mobileSettings"
                :style="{'pointer-events': `${isDragging ? 'none' : 'auto'}` }"
                >
              </post-item>
            </template>
          </ul>
        </div>
      </div>
      <div v-if="gallerySettings.layout == 'arrow' && ((isVerticalGallery && scrollTop > 0) || scrollWidth > 0)" :class="{ 'frisbuy-gallery-navigation': true, 'frisbuy-big': isLineRowsMode }">
        <div :class="{'frisbuy-navigation-button': true, 'frisbuy-gallery-next-navigation-button': true}" @click="slideHandler(true)">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 32" xml:space="preserve">
            <polyline stroke="currentColor" fill="none" points="16,24 8,16 16,8"/>
          </svg>
        </div>
        <span></span>
        <div :class="{'frisbuy-navigation-button': true, 'frisbuy-gallery-prev-navigation-button': true, }" @click="slideHandler(false)">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 32" xml:space="preserve">
            <polyline stroke="currentColor" fill="none" points="8,8 16,16 8,24"/>
          </svg>
        </div>
      </div>
    </div>
    <div v-if="gallerySettings.branding" :class="[{'frisbuy-branding': true}, gallerySettings.branding ]">
      Сделано на
      <a :href="settings.brandingLink || ('https://www.frisbuy.ru/?utm_source=gallery&utm_medium=referral&utm_campaign='+settings.customerCode)" rel="nofollow" target="_blank">
        <img :src="`${envDomain}/images/widget/frisbuy_logo_gray.svg`" alt="Frisbuy">
      </a>
    </div>
    <div class="frisbuy-footer">
      <div
        v-if="isShowLoadmoreButton"
        class="frisbuy-loadmore-button"
        :style="{ marginTop: gallerySettings.loadMore.marginTop + 'px'}"
        @click="loadMoreHandler"
      >
        {{ gallerySettings.loadMore.text || 'Ещё' }}
        <span v-if="inLoading" class="frisbuy-loadmore-loader"></span>
      </div>
      <div v-if="gallerySettings.footer.html" v-html="gallerySettings.footer.html"></div>
    </div>
    <div v-if="gallerySettings.guideline.html && isGuidlineOpen" class="frisbuy-guideline">
      <div class="frisbuy-guideline-container">
        <div v-html="gallerySettings.guideline.html"></div>
      </div>
    </div>
  </div>

  <Popup
    v-if="isShowPopup"
    :settings="settings"
    :mobileSettings="mobileSettings"
    :postList="postList"
    :post="currentPost"
    :postIndex="currentPostIndex"
    @changePost="(direction) => selectPost(postList[currentPostIndex + direction], currentPostIndex + direction)"
    @close="() => closePopup()"
  />
</template>

<style scoped src="./gallery.scss" lang="scss"></style>
<!-- Remove it from to client files -->
<style lang="scss" src="../../../gallery/themes/misslo.scss"></style>
<style lang="scss">
.frisbuy-gallery-navigation {
  position: absolute;
  display: flex;
  justify-content: space-between;
  top: calc(50% - 15px);
  width: 100%;
  height: 0;
  z-index: 10;

  &.frisbuy-big {
    top: calc(50% - 25px);

    .frisbuy-navigation-button {
      width: 50px;
      height: 50px;
    }
  }
}

.frisbuy-navigation-button {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 5px;
  box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  background-color: #fff;
  -webkit-backface-visibility: hidden;
  transition: transform 0.2s, box-shadow 0.2s, opacity 0.2s;
  opacity: 0.8;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }

  &.frisbuy-navigation-button-disabled {
    opacity: 0;
    pointer-events: none;
  }

  svg {
    color: #000;
    stroke-width: 3;
    width: 80%;
    height: 80%;
  }
}

/**
  /* Client Fix
  */

//goldenline
.frisbuy-widget img {
  width: unset;
}
</style>

<script>
// Modules
import { computed } from "vue";
import axios from "axios";
import smoothscroll from "smoothscroll-polyfill";
// Components
import Popup from "../../../gallery/popup/popup.vue";
// Services
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";

import Swiper, { Navigation, Scrollbar, EffectCreative } from "swiper";
import "swiper/css";
import "swiper/css/navigation";

const maxWidthDefault = 768;
const minWidthDefault = 414;
const scrollIndent = 12;

export default {
  components: { Popup },

  provide() {
    return {
      isMobile: computed(() => this.isMobile),
      isTablet: computed(() => this.isTablet),
    };
  },

  data() {
    return {
      settings: this.propSettings || {},
      layoutCounter: 0,
      pageNumber: 1,
      inLoading: false,
      hadSeen: false,
      had5SecInView: false,
      containerItemHeight: 0,
      containerRowsHeight: 0,
      scrollWidth: 0,
      scrollTop: 0,
      canPrevScroll: false,
      canNextScroll: false,
      popupInstance: null,
      containerWidthPx: 0,
      hoverTimeout: null,
      inViewTimeout: null,
      scrollTimeout: null,
      isGuidlineOpen: false,

      isMouseDown: false,
      isDragging: false,

      isShowPopup: false,
      currentPost: undefined,
      currentPostIndex: undefined,

      postList: this.propPostList || [],
      filterValue: undefined,
    };
  },

  props: [
    "propSettings",
    "mobileSettings",
    "propPostList",
    "extraData",
    "lastPage",
    "postCount",
  ],

  computed: {
    isMobile: {
      cache: false,
      get() {
        return this.containerWidthPx < 571;
      },
    },

    isTablet: {
      cache: false,
      get() {
        return this.containerWidthPx <= 768;
      },
    },

    widgetRefElement() {
      console.log(this.$refs["frisbuy-widget-gallery"]);
      return this.$refs["frisbuy-widget-gallery"];
    },

    isShowLoadmoreButton() {
      return (
        this.gallerySettings.layout == "tile" &&
        this.gallerySettings.loadMore.enable &&
        this.gallerySettings.loadMore.show &&
        !this.gallerySettings.loadMore.infinitePage &&
        this.postList.length < this.postCount
      );
    },

    gallerySettings: {
      cache: false,
      get() {
        return this.isMobile
          ? this.merge(this.settings.gallery, this.mobileSettings.gallery)
          : this.settings.gallery;
      },
    },

    headerSettings: {
      cache: false,
      get() {
        return this.gallerySettings.header;
      },
    },

    subTitleStyle() {
      const { subTitleMarginTop, subTitleMarginBottom } = this.headerSettings;

      return {
        marginTop:
          typeof subTitleMarginTop == "number" && `${subTitleMarginTop}px`,
        marginBottom:
          typeof subTitleMarginBottom == "number" &&
          `${subTitleMarginBottom}px`,
      };
    },

    galleryStyle() {
      const { marginTop, marginRight, marginBottom, marginLeft } =
        this.gallerySettings;

      return {
        marginTop: typeof marginTop == "number" && `${marginTop}px`,
        marginRight: typeof marginRight == "number" && `${marginRight}px`,
        marginBottom: typeof marginBottom == "number" && `${marginBottom}px`,
        marginLeft: typeof marginLeft == "number" && `${marginLeft}px`,
      };
    },

    isVerticalGallery() {
      return (
        this.gallerySettings.direction === "vertical" &&
        this.gallerySettings.layout != "tile"
      );
    },

    containerItemWidth: {
      cache: false,
      get() {
        const { containerWidthPx } = this;
        const { minCols, maxCols, layout, multiline } = this.gallerySettings;
        let { maxWidth, minWidth, fixedWidth } = this.gallerySettings.postItem;
        let totalCols = minCols;

        if (fixedWidth) return `${fixedWidth}px`;

        if (this.isVerticalGallery) {
          return `${100 / (multiline || 1)}%`;
        }

        maxWidth = maxWidth || maxWidthDefault;
        minWidth = minWidth || minWidthDefault;

        if (containerWidthPx > maxWidth) {
          totalCols = maxCols;
        } else if (containerWidthPx > minWidth) {
          const step = (maxWidth - minWidth) / (maxCols - minCols);
          const addCols = Math.floor((containerWidthPx - minWidth) / step);

          totalCols = parseInt(minCols) + (addCols > 0 ? addCols : 0);
        }

        return `${Math.floor(10000 / totalCols) / 100}%`;
      },
    },

    containerItemMargin: {
      cache: false,
      get() {
        const { margin } = this.gallerySettings.postItem;

        return parseInt(margin);
      },
    },

    isLineRowsMode: {
      cache: false,
      get() {
        return (
          this.gallerySettings.layout != "tile" &&
          this.gallerySettings.multiline > 1
        );
      },
    },
  },

  methods: {
    getFilterValue(url) {
      const { filters } = this.gallerySettings;
      const filterName = /tag=([^?&=]+)/.exec(decodeURIComponent(url)) || /segment_code=([^?&=]+)/.exec(decodeURIComponent(url));
      const filterValue =
        filterName &&
        ((filters && filters.params) || []).find(
          (filter) => filter.name == filterName[1]
        );

      return (filterValue && filterValue.value) || null;
    },

    resizeHandler() {
      this.containerWidthPx =
        this.getOffset(this.widgetRefElement).width ||
        Math.min(window.innerWidth, screen.width);

      const { isLineRowsMode, gallerySettings, postList, containerItemMargin } =
        this;
      const scrollElement = this.widgetRefElement.querySelector(
        ".frisbuy-scroll-wrapper"
      );

      setTimeout(() => {
        const item = this.widgetRefElement.querySelector(
          ".frisbuy-gallery-post"
        );
        const itemWidth = item && item.getBoundingClientRect().width;

        if (!item) return;

        this.containerItemHeight = Math.ceil(itemWidth);

        if (isLineRowsMode && postList.length) {
          this.containerRowsHeight = `${
            this.containerItemHeight * gallerySettings.multiline +
            containerItemMargin * gallerySettings.multiline +
            scrollIndent
          }px`;
          this.scrollWidth =
            itemWidth * Math.ceil(postList.length / gallerySettings.multiline) -
            scrollElement.clientWidth;
        } else {
          this.containerRowsHeight = "auto";
          this.scrollWidth =
            scrollElement.scrollWidth -
            scrollElement.clientWidth -
            this.containerItemMargin;
        }

        if (this.isVerticalGallery) {
          this.scrollTop =
            scrollElement.scrollHeight -
            scrollElement.clientHeight -
            this.containerItemMargin;
        }
      }, 100);
    },

    slideHandler(direction) {
      if (direction) {
        this.$refs.swiper.swiper.slidePrev();
      } else {
        this.$refs.swiper.swiper.slideNext();
      }
      this.sendAnaliticEvent(`Swipe`, { swipeType: "arrow" });
    },

    arrowScrollHandler() {
      const scrollElement = this.widgetRefElement.querySelector(
        ".frisbuy-scroll-wrapper"
      );

      setTimeout(() => {
        if (this.isVerticalGallery) {
          this.canPrevScroll = scrollElement.scrollTop > 0;
          this.canNextScroll =
            scrollElement.scrollTop +
              scrollElement.clientHeight +
              this.containerItemMargin <
            scrollElement.scrollHeight;
        } else {
          this.canPrevScroll = scrollElement.scrollLeft > 0;
          this.canNextScroll =
            scrollElement.scrollLeft +
              scrollElement.offsetWidth +
              this.containerItemMargin <
            scrollElement.scrollWidth;
        }
      }, 50);
    },

    // horizontalScrollHandler() {
    //   const items = this.widgetRefElement.querySelectorAll('.frisbuy-gallery-post');
    //   const scrollElement = this.widgetRefElement.querySelector('.frisbuy-scroll-wrapper');
    //   const lastItem = items[items.length -1];
    //   const { left } = lastItem.getBoundingClientRect();
    //   const { right } = scrollElement.getBoundingClientRect();

    //   if (this.gallerySettings.loadMore.enable && left < right) {
    //     this.loadMoreHandler();
    //   };
    // },

    filterQuery(url) {
      const { gallerySettings, filterValue } = this;
      const { filters } = gallerySettings;

      if (filterValue && filters) {
        const filterItem = (filters.params || []).find(
          (filter) => filter.value == filterValue
        );
        const filterField = filterItem.field || filters.field;

        if (filterField) {
          url += `&${filterField}=${filterValue}`;
        }
      }

      return (url += "&data=1");
    },

    scrollHandler() {
      const { layout } = this.gallerySettings;
      const { infinitePage, enable } = this.gallerySettings.loadMore;
      const firstItem = this.widgetRefElement.querySelector(
        ".frisbuy-gallery-post"
      );
      const InView5SecHandler = () => {
        this.had5SecInView = true;
        this.sendAnaliticEvent(
          "Eyesight5Sec",
          window.location.href,
          true,
          true
        );
      };

      this.$nextTick(() => {
        if (
          !this.had5SecInView &&
          this.isElementInView(this.widgetRefElement, true)
        ) {
          window.clearTimeout(this.inViewTimeout);

          this.inViewTimeout = setTimeout(InView5SecHandler, 5000);
        } else {
          window.clearTimeout(this.inViewTimeout);
        }

        if (
          !this.hadSeen &&
          this.isElementInView(firstItem || this.widgetRefElement, true)
        ) {
          this.hadSeen = true;
          this.sendAnaliticEvent("Eyesight", window.location.href, true, true);

          //  this.sendGATrack('Eyesight_gallery', window.location.href, true, true);
          //  this.sendYAMetrika('FrisbuyEyesight');
        }
      });
    },

    async loadMoreHandler() {
      const waitForLoading = new Promise(res => {
        const loadChecker = setInterval(() => {
          if (this.inLoading) {
            return;
          } else {
            clearInterval(loadChecker);
            res(true);
          }
        }, 1000);
      });

      await waitForLoading;

      const { settings, postList, filterQuery, loadMoreCallback, lastPage } =
        this;
      const { sourceUrl } = settings;
      const { sendNextPageToClient } = settings.analytics;
      const { frisbuyId } = postList[postList.length - 1].instagramPost;
      const { forceLimit, elasticFilterApplied } = settings.gallery;

      if (lastPage) return;

      let url = sourceUrl + "&last_post_id=" + frisbuyId;

      if (forceLimit) {
        url = url.concat("&force_limit_count=" + postList.length);
      }

      if (elasticFilterApplied) {
        url = url.concat(`&ef_applied=1`);
      }

      if (!frisbuyId) {
        return;
      }

      url = filterQuery(url);

      if (loadMoreCallback) {
        url = loadMoreCallback(url);
      }

      this.getPosts(url, () => {
        this.sendAnaliticEvent(
          "NextPage",
          ++this.pageNumber,
          sendNextPageToClient
        );
      });
    },

    getFilterPosts(event) {
      this.filterValue = this.getFilterValue(window.location.hash);

      const { settings, getFilterValue, filterQuery, isTablet } = this;

      if (event && getFilterValue(event.newURL) == getFilterValue(event.oldURL))
        return;

      axios
        .get(filterQuery(settings.sourceUrl))
        .then((response) => {
          const { posts, lastPage } = response.data;

          this.postList = posts;

          this[
            isTablet ? "mobileSettings" : "settings"
          ].gallery.loadMore.enable = !lastPage;

          if (!lastPage) {
            this.$nextTick(this.onScroll);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    parseHash() {
      // NOTE: `post_id` - legacy that used to support links with it
      const FRISBUY_POST_ID_PARAMS = ["prov_post_id", "post_id"];

      const params = window.location.hash.slice(1).split("&");
      const { settings, postList } = this;

      // TODO: check `hasOpenPopup`. I think it doesn't work
      const hasOpenPopup = Object.keys(window.frisbuy).some((property) => {
        const frisbuyProperty = window.frisbuy[property];

        return (
          typeof frisbuyProperty == "object" &&
          frisbuyProperty.popup &&
          frisbuyProperty.popup.post
        );
      });

      // HACK: Flag to check if link contains more than one of FRISBUY_POST_ID_PARAMS
      let isAlreadyParsedPost = false;

      params.forEach((hashParam) => {
        let [key, value] = hashParam.split("=");

        if (!hasOpenPopup && hashParam.match(/&?advertising=\w+/)) {
          setTimeout(() => {
            const { advertising } = this.$refs;
            const adPost = advertising.find(
              (post) => post.$options.propsData.index === parseInt(value)
            );
            adPost.$data.showPopup = true;
          }, 0);
        }

        let param = /^fri_(.+)/.exec(key);

        if (!param) return;

        param = param[1];

        try {
          value = JSON.parse(decodeURI(value));
        } catch (error) {
          value = decodeURI(value);
        }

        if (FRISBUY_POST_ID_PARAMS.includes(param) && !hasOpenPopup) {
          if (isAlreadyParsedPost) {
            return;
          }
          isAlreadyParsedPost = true;

          // NOTE: frisbuyPost.id - legacy
          const post = postList.find(
            (post) =>
              post.frisbuyPost.id == value ||
              post.instagramPost?.frisbuyId == value ||
              post.providerPost?.frisbuyId == value
          );
          const source = settings.sourceUrl.replace(/last_post=\d*\&?/, "");

          if (!post) {
            axios({
              url: DomainSubstitute(`${source}&${param}=${value}`),
            }).then(({ data }) => {
              this.showPost(data.posts[0]);
            });
          } else {
            this.showPost(post, postList.indexOf(post));
          }
        } else {
          /*
            NOTE: We can change some gallery setting by set settings in hash...
            Exaple:
              localhost:8080/gallery.html#fri_gallery.header.subTitle=asd
                converts to -> this.settings.gallery.header.subTitle = asd;
            IDK. It just exists...
            I just refactored this to use one function
          */
          this.updateSettings(`settings.${param}`, value);
        }
      });
    },

    showPost(post, index) {
      const { settings, mobileSettings, postList } = this;
      const {
        popup: { targetBlankLink },
        popupContainer
      } = settings;
      const { skipPopup } = this.gallerySettings;

      if (!post) return;

      if (
        skipPopup &&
        post.media.reduce(
          (totalLinks, media) => totalLinks + media.linkList.length,
          0
        ) === 1
      ) {
        const media = post.media.find(
          (media) => media.linkList.length && media.linkList[0]
        );
        const link = media.linkList[0];

        this.sendAnaliticEvent("ClickLink", {
          provPostId:
            post.instagramPost?.frisbuyId ?? post.providerPost.frisbuyId,
          fbProduct: post.frisbuyPost.id,
          igCode: post.instagramPost.shortcode,
          link: link.link,
          linklabel: link.title,
          offer: link.sku.offerId,
        });

        if (targetBlankLink) {
          window.open(link.link).focus();
        } else {
          window.location.replace(link.link);
        }
      } else {
        this.selectPost(post, index);
      }
    },

    selectPost(post, index) {
      let selectedPost = post;
      let selectedPostIndex = index;

      /*
        FIXME:
        The ad post is currently being ignored on select from popup navigation.
        This post should be selected like a default post.
      */
      if (selectedPost?.frisbuyPost.type === "advertising") {
        const step = selectedPostIndex - this.currentPostIndex;
        selectedPostIndex = this.currentPostIndex + step * 2;
        selectedPost = this.postList[selectedPostIndex] || this.postList[0];
      }

      this.currentPost = selectedPost;
      this.currentPostIndex = selectedPostIndex;
      this.isShowPopup = true;

      if (!selectedPost) {
        if (selectedPostIndex > 0) {
          const firstPost = this.postList[0];
          this.currentPost = firstPost;
          this.currentPostIndex = 0;
        } else if (selectedPostIndex < 0) {
          const lastPostIndex = this.postList.length - 1;
          const lastPost = this.postList[lastPostIndex];

          this.currentPost = lastPost;
          this.currentPostIndex = lastPostIndex;
        }

        return;
      }
    },

    closePopup() {
      this.currentPost = undefined;
      this.currentPostIndex = undefined;
      this.isShowPopup = false;
    },

    clickPostHandler(post, index) {
      this.sendAnaliticEvent("ClickPic", {
        provPostId:
          post.instagramPost?.frisbuyId ?? post.providerPost.frisbuyId,
        fbProduct: post.frisbuyPost.id,
        igCode: post.instagramPost.shortcode,
      });

      // this.sendGATrack('ClickPic_gallery', `fbProduct${ post.frisbuyPost.id }_igCode${ post.instagramPost.shortcode }`);
      // this.sendYAMetrika('FrisbuyClickPic', index);

      this.showPost(post, index);
    },

    trackMainLinkClick(igUsername) {
      this.sendAnaliticEvent(`ClickMainLink${this.actionPrefix}`, igUsername);

      // this.sendGATrack({ name: `ClickMainLink${this.actionPrefix}`, onlyName: true }, igUsername);
      // this.sendYAMetrika('FrisbuyClickMainLink');
    },

    getPosts(url, analyticEvent) {
      const { postList, isTablet } = this;

      this.inLoading = true;

      axios
        .get(url)
        .then((response) => {
          const { posts, lastPage } = response.data;

          if (posts && posts.length) {
            postList.push(...posts);

            if (analyticEvent) {
              analyticEvent(response.data);
            }

            this.$nextTick(() => {
              this.scrollHandler();
              this.resizeHandler();
              this.arrowScrollHandler();
            });
          }

          this.inLoading = false;

          this[
            isTablet ? "mobileSettings" : "settings"
          ].gallery.loadMore.enable = !lastPage;
        })
        .catch((error) => {
          console.log("LoadMore error", error);
          this.inLoading = false;
        });
    },

    swipeHandler(direction) {
      const { slideHandler, isMobile, gallerySettings } = this;

      return;
      if (gallerySettings != "arrow" || !isMobile) return;

      switch (direction) {
        case "left":
          slideHandler(1);
          break;
        case "right":
          slideHandler(-1);
          break;
      }
    },

    handleMouseDownScroll(event) {
      if (!this.settings.gallery.isSwipeEnabled) return;

      const { postsScroll } = this.$refs;

      this.isMouseDown = true;

      postsScroll.classList.add("active-grab-scroll");

      this.startX = event.pageX - postsScroll.offsetLeft;

      this.dragScrollLeft = postsScroll.scrollLeft;
    },

    handleMouseLeaveScroll() {
      this.isMouseDown = false;

      setTimeout(() => (this.isDragging = false), 0);

      this.$refs.postsScroll.classList.remove("active-grab-scroll");
    },

    handleMouseUpScroll(e) {
      this.isMouseDown = false;

      setTimeout(() => (this.isDragging = false), 0);

      this.$refs.postsScroll.classList.remove("active-grab-scroll");
    },

    handleMouseMoveScroll(event) {
      if (!this.isMouseDown) return;

      event.preventDefault();

      const { postsScroll } = this.$refs;

      const initialScrollLeft = postsScroll.scrollLeft;

      const pageX = event.pageX - postsScroll.offsetLeft;

      const walk = (pageX - this.startX);

      postsScroll.scrollLeft = this.dragScrollLeft - walk;

      if (initialScrollLeft !== postsScroll.scrollLeft) {
        this.isDragging = true;
      }
    },

    startCountHover(event) {
      const { startCountHover, clearCountHover } = this;

      this.hoverTimeout = setTimeout(() => {
        this.sendAnaliticEvent(`Hover2Sec`, window.location.href);
        this.widgetRefElement.removeEventListener(
          "mouseenter",
          startCountHover
        );
        this.widgetRefElement.removeEventListener(
          "mouseleave",
          clearCountHover
        );
      }, 2000);
    },

    clearCountHover(event) {
      if (window.frisbuy.popup && window.frisbuy.popup.post) return;

      window.clearTimeout(this.hoverTimeout);
    },

    scrollPostsHandler() {
      window.clearTimeout(this.scrollTimeout);

      this.scrollTimeout = window.setTimeout(() => {
        this.sendAnaliticEvent(`Swipe`, { swipeType: "line" });
      }, 500);
    },

    chosenFilter(filter) {
      this.sendAnaliticEvent("ClickFilter", {
        filter: filter.name || "Все",
      });
    },

    toggleGuideline() {
      if (!this.isGuidlineOpen) {
        this.sendAnaliticEvent("Open_guide", window.location.href);
      }

      this.isGuidlineOpen = !this.isGuidlineOpen;
    },

    updateSettings(path, value) {
      const nodes = path.split(".");
      const settingsType = nodes.shift();
      const lastNode = nodes[nodes.length - 1];

      let source = nodes.reduce((source, node) => {
        if (node === lastNode) return source;

        if (!source || !source.hasOwnProperty(node)) return;
        return source[node];
      }, this[settingsType]);

      if (!source) return console.error("Can't find source by path.");

      source[lastNode] = value;
    },

    postMessageHandler(event) {
      const { data } = event;
      if (
        !event.origin.includes("frisbuy") ||
        !data ||
        !data.hasOwnProperty("property")
      )
        return;

      this.$nextTick(() => {
        this.updateSettings(data.property, data.value);

        this.resizeHandler();
      });

      setTimeout(() => {
        this.resizeHandler();
        this.arrowScrollHandler();
      }, 0);
    },
  },

  beforeMount() {
    const { script: scriptCode } = this.settings.common;

    if (scriptCode) {
      const head = document.querySelector("head");
      const script = document.createElement("script");

      script.type = "text/javascript";

      try {
        script.appendChild(document.createTextNode(scriptCode));
      } catch (e) {
        script.text = scriptCode;
      }

      head.insertBefore(script, head.firstChild);
    }
  },

  mounted() {
    const {
      $el,
      resizeHandler,
      scrollHandler,
      arrowScrollHandler,
      settings,
      startCountHover,
      clearCountHover,
      postMessageHandler,
    } = this;
    const { postsScroll } = this.$refs;
    const { infinitePage, enable } = this.gallerySettings.loadMore;
    const { layout } = settings.gallery;
    const { embedId, widgetStart } = settings;
    const entries = (performance && performance.getEntries()) || null;
    const times = {};
    const scrollElement = this.widgetRefElement.querySelector(
      ".frisbuy-scroll-wrapper"
    );
    const viewport = document.querySelector("meta[name=viewport]");
    const observerGalleryHandler = (mutationList) => {
      if (document.body.contains(this.widgetRefElement)) return;

      // Destorying the component (this.$destroy in Vue2)
      this.$.appContext.app.unmount();
      observerGallery.disconnect();
    };
    const observerGallery = new MutationObserver(observerGalleryHandler);

    if (!viewport) {
      const metaTag = document.createElement("meta");
      metaTag.name = "viewport";
      metaTag.content = "width=device-width, height=device-height";
      document.querySelector("head").appendChild(metaTag);
    }

    smoothscroll.polyfill();

    if (settings.vorlon) {
      const vorlonScript = document.createElement("script");
      vorlonScript.onload = function () {
        VORLON.Core.StartClientSide("https://vorlon.frisbuy.com/", "default");
      };
      vorlonScript.src = "//vorlon.frisbuy.com/vorlon.max.autostartdisabled.js";
      document.body.appendChild(vorlonScript);
    }

    if (entries) {
      if (widgetStart) {
        times.domInject = (performance.now() - widgetStart).toFixed(2);
      }

      entries.forEach((entry) => {
        if (entry.name.includes(embedId)) {
          times.queued = entry.startTime.toFixed(2);
          times.load = entry.duration.toFixed(2);
        } else if (
          entry.name.includes("www.frisbuy.ru") &&
          entry.name.includes("compiled")
        ) {
          times.bundle = entry.duration.toFixed(2);
        }
      });

      this.sendAnaliticEvent("TimeLoad", times, false, true);
    }

    this.sendAnaliticEvent("Load", window.location.href, true, true);

    if (settings.gallery.elasticFilter) { // TODO: see analytics.elasticFilter and rewrite this. Remove gallery.elasticFilter from backend params
      this.sendAnaliticEvent("FilterElastic", window.location.href, true, true);
    }

    observerGallery.observe(document.body, { childList: true });

    /*
      TODO: This addEventListener is realy needed?
      Does this slow down the widget?
    */
    resizeHandler();
    window.addEventListener("resize", resizeHandler);

    scrollHandler();
    window.addEventListener("scroll", scrollHandler);

    if (postsScroll && layout == "line") {
      postsScroll.addEventListener("scroll", this.scrollPostsHandler);
    }

    // swiper

    const swiper = new Swiper(this.$refs.swiper, {
      modules: [Navigation, Scrollbar],

      speed: 500,

      loop: true,
      slidesPerGroup: 1,
      slidesPerView: 2,
      spaceBetween: 20,
      loadPrevNextAmount: 4,

      breakpoints: {
        623: {
          slidesPerView: 3,
        },
        800: {
          slidesPerView: 4,
        },
      },

      navigation: {
        nextEl: ".frisbuy-gallery-next-navigation-button",
        prevEl: ".frisbuy-gallery-prev-navigation-button",
        disabledClass: "frisbuy-navigation-button-disabled",
      },

      scrollbar: {
        draggable: true,
      },
    });

    swiper.on("click", (swiper, event) => {
      const postIndex = swiper.clickedSlide.dataset.swiperSlideIndex;
      if (typeof postIndex !== "undefined") {
        if (postIndex === -1) {
          this.clickPostHandler(this.postList[this.postList.length - 1], this.postList.length - 1);
        } else {
          this.clickPostHandler(this.postList[postIndex], Number(postIndex));
        }
      }
    })

    // swiper end

    const component = this;

    window.addEventListener("message", postMessageHandler);

    window.frisbuyGuideline = {
      toggle() {
        component.toggleGuideline();
      },
    };

    arrowScrollHandler();
    scrollElement.addEventListener("scroll", arrowScrollHandler);

    if (this.isTablet) return;

    this.widgetRefElement.addEventListener("mouseenter", startCountHover);
    this.widgetRefElement.addEventListener("mouseleave", clearCountHover);
  },

  created() {
    const { getFilterPosts, parseHash } = this;
    const {
      buttonStyle,
      buttonStyleHover,
      script: scriptCode
    } = this.settings.common;
    const tempNode = document.createElement("DIV");
    const { body } = document;

    // TODO: Broken svg.
    // tempNode.innerHTML = sprites;

    // body.insertBefore(tempNode.firstChild, body.firstChild);

    parseHash();
    window.addEventListener("hashchange", parseHash);

    this.filterValue = this.getFilterValue(window.location.hash);

    if (this.filterValue) {
      getFilterPosts();
    }

    window.addEventListener("hashchange", getFilterPosts);

    /**
     * Add button styles from settings
     */

    if (!buttonStyle && !buttonStyleHover) return;

    document.head.insertAdjacentHTML(
      "beforeend",
      `<style>
        .frisbuy-widget .frisbuy-footer .frisbuy-loadmore-button {
          ${buttonStyle}
        }
        .frisbuy-widget .frisbuy-footer .frisbuy-loadmore-button:hover {
          ${buttonStyleHover}
        }
        div.frisbuy-popup .frisbuy-products-list a.frisbuy-product-item button {
          ${buttonStyle}
        }
        div.frisbuy-popup .frisbuy-products-list a.frisbuy-product-item button:hover {
          ${buttonStyleHover}
        }
      </style>`
    );
  },

  beforeUnmount() {
    const { resizeHandler, scrollHandler, popupInstance, postMessageHandler } =
      this;

    window.removeEventListener("resize", resizeHandler);
    window.removeEventListener("scroll", scrollHandler);
    window.removeEventListener("message", postMessageHandler);

    if (popupInstance) {
      popupInstance.$destroy();
    }
  },

  watch: {
    canNextScroll(value) {
      if (!value) {
        this.loadMoreHandler();
      }
    },
  },
};
</script>
